import PropTypes from 'prop-types';
import React from 'react';
import ErrorBoundary from '../../../../../../../common/components/ErrorBoundary';
import Component from './component';

function ChargerConfigurationTextField(props) {
  return (
    <ErrorBoundary errorFallback="Error in Charger Configuration Field">
      <Component {...props} />
    </ErrorBoundary>
  );
}

ChargerConfigurationTextField.propTypes = {
  multiline: PropTypes.bool,
  label: PropTypes.string,
  type: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  meta: PropTypes.object,
  input: PropTypes.object,
  onChange: PropTypes.func,
};

export default ChargerConfigurationTextField;
